import React, {PureComponent} from 'react'
import {storageGet, storageSet} from '../utils/storage'
import {updateStatsCache} from '../api'

import AdminColumnToggle from '../components/Filters/Fields/AdminColumnToggle'
import AdminTable from '../components/Table/AdminTable'
import Loader from '../components/Simple/Loader'
import AdminFilterInput from '../components/Filters/TableFilters/AdminFilterInput'
import FilterContainer from '../components/Filters/FilterContainer'
import AutoGraph from '../components/Chart/AutoGraph'
import ApplicationModal from '../components/Application/ApplicationModal'
import Button from '@material-ui/core/Button'

export default class AdminPanelView extends PureComponent {
    state = {
        items: [],
        viewType: '',
        childViewType: '',
        availableColumns: [],
        availableChildColumns: [],
        showChilds: false,
        showChildHeader: true,
        openDetailIds: [],
        filters: {limit: 50},
        isLoading: true,
        cacheUpdating: false,
        search: '',
        isModalVisible: true
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    componentDidMount() {
        this.init()
        this.props.setPageTitle(this.props.title)
    }

    init = (filters = []) => {
        const updateState = response => {
            const config = response.data.config
            const data = response.data.data

            const defaultSettings = this.setDefaultColumnsIfNeeded(config, data.user)

            const settings = this.getSettings(config.viewType, config.childViewType)

            const savedFilters = Object.assign(config.defaultPresetFilters, settings[config.viewType + 'SavedFilters'])

            const newState = {
                ...settings,
                items: data.items,
                series: data.series,
                availableColumns: config.availableColumns,
                availableChildColumns: config.availableChildColumns,
                isLoading: false,
                viewType: config.viewType,
                childViewType: config.childViewType,
                [config.viewType + 'SavedFilters']: savedFilters,
                user: data.user
            }

            for (let defaultSettingKey in defaultSettings) {
                if (!newState[defaultSettingKey]) {
                    newState[defaultSettingKey] = defaultSettings[defaultSettingKey]
                }
            }

            this.props.setUser(data.user)

            this.setState(newState, () => {
                this.setSettings('viewType', this.state.viewType, false)
                this.setSettings('childViewType', this.state.childViewType, false)
            })
        }

        this.setState({isLoading: true, items: []}, () => {
            this.props
                .initSrc(filters, this.state.viewType)
                .then(updateState)
                .catch(err => {
                    alert(err)
                })
        })
    }

    update = filters => {
        const updateState = response => {
            const data = response.data

            const newState = {
                items: data.items,
                series: data.series,
                isLoading: false
            }
            this.setState(newState)
        }

        this.setState({isLoading: true, items: []}, () => {
            this.props
                .dataSrc(filters, this.state.viewType)
                .then(updateState)
                .catch(err => {
                    alert(err)
                })
        })
    }

    setDefaultColumnsIfNeeded = (config, user) => {
        let obj = {}
        if (user.type === 'admin' && config.defaultAdminColumns) {
            obj[config.viewType + 'VisibleColumns'] = config.defaultAdminColumns
            obj[config.childViewType + 'VisibleColumns'] = config.defaultAdminChildColumns
        } else {
            obj[config.viewType + 'VisibleColumns'] = config.defaultColumns
            obj[config.childViewType + 'VisibleColumns'] = config.defaultChildColumns
        }
        return obj
    }

    toggleShowChildren = e => () => {
        const showChilds = !this.state.showChilds
        this.setSettings('showChilds', showChilds)
    }

    toggleChildHeader = e => () => {
        const showChildHeader = !this.state.showChildHeader
        this.setSettings('showChildHeader', showChildHeader)
    }

    getSettings = (viewType, childViewType) => {
        let obj = {
            [viewType + 'VisibleColumns']: this.getSetting(viewType + 'VisibleColumns'),
            [childViewType + 'VisibleColumns']: this.getSetting(childViewType + 'VisibleColumns'),
            [viewType + 'SavedFilters']: this.getSetting(viewType + 'SavedFilters'),
            showChilds: this.getSetting('showChilds'),
            showChildHeader: this.getSetting('showChildHeader')
        }
        return obj
    }

    getSetting = key => {
        const value = storageGet(key)
        if (value) {
            return JSON.parse(value)
            //this.setState({[key]: JSON.parse(value)})
        }
        return null
    }

    setSettings = (key, value, update = true) => {
        storageSet(key, value)
        if (update) {
            this.setState({[key]: value})
            this.forceUpdate()
        }
    }

    onColumnChange = (columns, alias) => {
        this.setSettings(alias, columns)
    }

    onViewTypeSelect = e => {
        this.table.current.clearShowDetailIds()

        const viewType = e.target.value
        const childViewType = viewType === this.state.viewType ? this.state.childViewType : this.state.viewType
        this.setSettings('viewType', viewType)
        this.setSettings('childViewType', childViewType)
        this.setState({viewType: viewType, childViewType: childViewType, isLoading: true, filters: {}}, () => this.update(this.state.filters))
    }

    onLimitSelect = e => {
        this.table.current.clearShowDetailIds()

        const limit = e.target.value
        this.addFilter({limit: limit})
    }

    handleSearchSubmit = e => {
        e.preventDefault()
        this.table.current.clearShowDetailIds()
        this.addFilter({search: 'search|' + this.state.search})
    }

    onSearchChanged = e => {
        const search = e.target.value
        this.setState({search: search}, () => {
        })
    }

    onCountrySelect = e => {
        this.table.current.clearShowDetailIds()

        const country = e.target.value
        if (country !== '') {
            this.addFilter({country: 'equals|' + country})
        } else {
            this.removeFilter('country')
        }
    }

    addFilter = newFilter => {
        const filters = {
            ...this.state.filters,
            ...newFilter
        }
        this.setState({
            filters: filters,
            offset: 0
        })
        this.update(filters)
    }

    removeFilter = removeFilter => {
        delete this.state.filters[removeFilter]
        this.update(this.state.filters)
    }

    getSavedFilters = () => {
        return this.state[this.state.viewType + 'SavedFilters']
    }

    setSavedFilters = key => {
        const filters = {...this.state[this.state.viewType + 'SavedFilters'][key]}
        this.setState({filters: filters, search: ''}, () => this.update(filters))
    }

    saveFilters = key => {
        let filters = this.state.filters
        filters.default = false

        const savedFilters = {
            ...this.state[this.state.viewType + 'SavedFilters'],
            ...{
                [key]: {...filters}
            }
        }
        this.setSettings(this.state.viewType + 'SavedFilters', savedFilters)
    }

    removeSavedFilters = removeFilter => {
        const r = window.confirm('Do you really want to remove this preset?')
        if (r === false) {
            return
        }
        delete this.state[this.state.viewType + 'SavedFilters'][removeFilter]
        this.setSettings(this.state.viewType + 'SavedFilters', this.state[this.state.viewType + 'SavedFilters'])
    }

    getVisibleColumns = () => {
        const visibleColumns = this.state[this.state.viewType + 'VisibleColumns']
        if (!visibleColumns) {
            return []
        }
        return this.state.availableColumns.filter(item => visibleColumns.indexOf(item.name) >= 0)
    }

    getVisibleChildColumns = () => {
        const visibleChildColumns = this.state[this.state.childViewType + 'VisibleColumns']
        if (!visibleChildColumns) {
            return []
        }
        return this.state.availableChildColumns.filter(item => visibleChildColumns.indexOf(item.name) >= 0)
    }

    updateStatsCache() {
        if (window.confirm('Data will take couple minutes to update after starting this operation. Confirm.')) {
            this.setState({cacheUpdating: true})
            updateStatsCache().then(response => {
                this.setState({cacheUpdating: false})
                setTimeout(() => {
                    window.alert('Data update complete!')
                    this.update(this.state.filters)
                }, 50)
            })
        }
    }

    onFileExport = () => {
        this.props.export(this.state.filters, this.state.viewType, this.state[this.state.viewType + 'VisibleColumns'])
    }

    toggleModal = () => this.setState({isModalVisible: !this.state.isModalVisible})

    render() {
        const savedFilters = this.getSavedFilters()
        const showDetails = this.showDetails
        const visibleColumns = this.getVisibleColumns()
        const visibleChildColumns = this.getVisibleChildColumns()
        const checkedChildColumns = this.state[this.state.childViewType + 'VisibleColumns']
        const checkedColumns = this.state[this.state.viewType + 'VisibleColumns']
        const {isModalVisible, user} = this.state

        return (
            <div
                style={{minHeight: '70vh'}}
                className={!(user && (user.type === 'client' || user.type === 'affiliate' || user.type === 'admin')) ? 'simple-panel-view' : ''}
            >
                {false && (
                    <Button onClick={this.toggleModal} style={{marginBottom: 32}}>
                        Toggle
                    </Button>
                )}
                {user && (user.type === 'client' || user.type === 'affiliate' || user.type === 'admin') && (
                    <FilterContainer
                        isLoading={this.state.isLoading}
                        showChilds={this.state.showChilds}
                        showChildHeader={this.state.showChildHeader}
                        columns={visibleColumns}
                        childColumns={visibleChildColumns}
                        showDetails={showDetails}
                        filters={this.state.filters}
                        onAddFilter={this.addFilter}
                        onRemoveFilter={this.removeFilter}
                        savedFilters={savedFilters}
                        onSetSavedFilters={this.setSavedFilters}
                        onSaveFilters={this.saveFilters}
                        onRemoveSavedFilters={this.removeSavedFilters}
                        availableColumns={this.state.availableColumns}
                        viewType={this.state.viewType}
                        childViewType={this.state.childViewType}
                        onSearchChanged={this.onSearchChanged}
                        handleSearchSubmit={this.handleSearchSubmit}
                        onViewTypeSelect={this.onViewTypeSelect}
                        checkedChildColumns={checkedChildColumns}
                        checkedColumns={checkedColumns}
                        updateStatsCache={this.updateStatsCache}
                        onFileExport={this.onFileExport}
                        availableChildColumns={this.state.availableChildColumns}
                        country={this.state.country}
                        onCountrySelect={this.onCountrySelect}
                        onLimitSelect={this.onLimitSelect}
                        onColumnChange={this.onColumnChange}
                        search={this.state.search}
                        toggleShowChildren={this.toggleShowChildren}
                        update={this.update}
                        toggleChildHeader={this.toggleChildHeader}
                        cacheUpdating={this.state.cacheUpdating}
                        limit={this.state.limit}
                    />
                )}
                <div
                    className="admin-chart-box admin-chart-box-shadow"
                    hidden={!(user && (user.type === 'client' || user.type === 'affiliate' || user.type === 'admin'))}
                >
                    <div className="admin-chart-wrapper">
                        <AutoGraph isLoading={this.state.isLoading} series={this.state.series}/>
                    </div>
                </div>
                <AdminTable
                    items={this.state.items}
                    isLoading={this.state.isLoading}
                    showChilds={this.state.showChilds}
                    showChildHeader={this.state.showChildHeader}
                    columns={visibleColumns}
                    childColumns={visibleChildColumns}
                    showDetails={showDetails}
                    filters={this.state.filters}
                    onAddFilter={this.addFilter}
                    onRemoveFilter={this.removeFilter}
                    savedFilters={savedFilters}
                    onSetSavedFilters={this.setSavedFilters}
                    onSaveFilters={this.saveFilters}
                    onRemoveSavedFilters={this.removeSavedFilters}
                    availableColumns={this.state.availableColumns}
                    viewType={this.state.viewType}
                    ref={this.table}
                />
                {isModalVisible && false && <ApplicationModal toggle={this.toggleModal}/>}
            </div>
        )
    }
}
